export const LoadingItemStyles = {
  item: 'py-3',
}
